export default {
  props: {
    modelValue: {
      default: undefined,
    },
    value: {
      default: undefined,
    },
  },

  emits: ['update:modelValue', 'input'],

  computed: {
    boundValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },
  },

  methods: {
    emitBoundValue(next) {
      this.$emit('update:modelValue', next);
      this.$emit('input', next);
    },
  },
};
